import { DEFAULT_PRICING, localitySlug } from "../lib/api";

export default function CoverageLinksSection({ currentSlug = null }) {
  return (
    <section aria-label="Localități acoperite" className="border-t border-white/5 bg-hydro-navy py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
          Acoperire
        </p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
          Forăm în tot Ilfovul și București.
        </h2>
        <div className="mt-8 flex flex-wrap gap-2">
          {DEFAULT_PRICING.localities.map((l) => {
            const slug = localitySlug(l.name);
            const active = slug === currentSlug;
            return (
              <a
                key={l.name}
                href={`/foraje-puturi/${slug}`}
                data-testid={`coverage-link-${slug}`}
                className={`rounded-full border px-4 py-2 text-xs font-bold transition-colors ${
                  active
                    ? "border-hydro-cyan bg-hydro-cyan/10 text-hydro-cyan"
                    : "border-white/15 text-white/60 hover:border-hydro-cyan hover:text-hydro-cyan"
                }`}
              >
                {l.name}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
